import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Col,
  Row,
  Button,
  Input,
} from "reactstrap";

import Select from "react-select";
//redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
//react router dom
import { useLocation } from "react-router-dom";
//service
import { getGroups } from "../../../utils/services/group";
import { createSchedule } from "../../../utils/services/schedule";
import { createScheduleQuotas } from "../../../utils/services/scheduleCotas";
import { getUrlFiles } from "../../../utils/services/files";
import { getAllSpeakers } from "../../../utils/services/speaker";

import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";

function NewSchedule(props) {
  const { isOpen, toggle } = props;
  const location = useLocation();
  const [isLoading, setIsloading] = useState(false);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startHour, setStartHour] = useState("");
  const [endHour, setEndHour] = useState("");
  const [img1, setImg1] = useState(null);
  const [img2, setImg2] = useState(null);
  const [img3, setImg3] = useState(null);
  const [img4, setImg4] = useState(null);
  const [img5, setImg5] = useState(null);
  const [order, setOrder] = useState(null);
  const [typeOrLocation, setTypeOrLocation] = useState("");
  const [qtdQuotas, setQtdQuotas] = useState("");

  const [backgroundColor, setBackgroundColor] = useState("#FFFFFF");
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [groups, setGroups] = useState([]);
  const [groupsMulti, setGroupsMulti] = useState([]);
  const [speakers, setSpeakers] = useState([]);
  const [speakersMulti, setSpeakersMulti] = useState([]);

  const allGroups = groupsMulti.some((e) => e.value === "todos");
  const allSpeakers = speakersMulti.some((e) => e.value === "todos");
  const [titleError, setTitleError] = useState("");
  const [dateError, setDateError] = useState("");
  const [quotasError, setQuotasError] = useState("");
  const [hourStartError, setHourStartError] = useState("");
  const [hourEndError, setHourEndError] = useState("");

  function checkProductExists(product) {
    if (!location.state) return false;
    return location.state.event.product.some((e) => e.name === product);
  }

  function handleGroupMulti(a) {
    const hasTodos = a.some((e) => e.value === "todos");
    setGroupsMulti(hasTodos ? a.filter((e) => e.value === "todos") : a);
  }

  function handleSpeakersMulti(a) {
    const hasTodos = a.some((e) => e.value === "todos");
    setSpeakersMulti(hasTodos ? a.filter((e) => e.value === "todos") : a);
  }

  function getSpeakers() {
    getAllSpeakers(props.idEvent, 1, 999, "", "").then((res) => {
      if (res.data.message === "findAllPalestrantes") {
        setSpeakers(res.data.findAllPalestrantes.data);
      }
    });
  }

  const isComGas = () => checkProductExists("Distribuição de Cotas");
  const isApp = () => checkProductExists("APP Eventos Plus");
  const isRsvp = () => checkProductExists("RSVP");

  async function funcPhoto() {
    let pictures = [];
    if (isApp() || isRsvp()) {
      let haveImg = false;
      let data = new FormData();
      if (img1 && img1.type.startsWith("image/")) {
        data.append("files", img1);
        haveImg = true;
      }
      if (img2 && img2.type.startsWith("image/")) {
        data.append("files", img2);
        haveImg = true;
      }
      if (img3 && img3.type.startsWith("image/")) {
        data.append("files", img3);
        haveImg = true;
      }
      if (img4 && img4.type.startsWith("image/")) {
        data.append("files", img4);
        haveImg = true;
      }

      if (img5 && img5.type.startsWith("image/")) {
        data.append("files", img5);
        haveImg = true;
      }
      data.append("folder", "agenda");
      data.append("eventId", props.idEvent);

      if (haveImg) {
        try {
          const response = await getUrlFiles(
            data,
            props.state.global_user_data.data.token,
          );

          response.forEach((img) => {
            if (img) {
              pictures.push({ image: img.url, expires: img.expires });
            }
          });
        } catch (error) {
          setErrorAlert(true);
          return;
        }
      }
    }

    submitForm(pictures);
  }

  function formatDateTime(date, time) {
    return `${date}T${time || "00:01"}`;
  }

  // Envia o formulário após o upload das imagens
  async function submitForm(pictures) {
    setTitleError("");
    setDateError("");
    setHourStartError("");
    setQuotasError("");
    setHourEndError("");

    if (title === "") {
      setTitleError("O campo Titulo é obrigatório.");
      return;
    }

    if (startDate === "") {
      setDateError("O campo é obrigatório.");
      return;
    }

    const hasStartHour = startHour !== "";
    const hasEndHour = endHour !== "";

    if (!hasStartHour && hasEndHour) {
      setHourStartError("O campo Hora Inicio deve ser informado.");
      return;
    }

    if (hasStartHour && hasEndHour && endHour < startHour) {
      setHourEndError("O campo Hora Fim deve ser maior que Hora Início.");
      return;
    }

    if (isComGas() && !qtdQuotas) {
      setQuotasError("O campo Quantidade de Cotas é obrigatório");
      return;
    }

    setIsloading(true);

    const groupsArray = allGroups
      ? groups.map((e) => e.id)
      : groupsMulti.map((e) => e.value);

    const speakersArray = allSpeakers
      ? speakers.map((e) => e.id)
      : speakersMulti.map((e) => e.value);

    try {
      const dataApi = {
        eventId: props.idEvent,
        startDate: formatDateTime(startDate, startHour),
        startHour,
        endHour,
        title,
        description,
        typeOrLocation,
        color: backgroundColor,
        picture: pictures[0]?.image || null,
        picture2: pictures[1]?.image || null,
        picture3: pictures[2]?.image || null,
        picture4: pictures[3]?.image || null,
        picture5: pictures[4]?.image || null,
        palestrantes: speakersArray,
        groups: groupsArray,
        jwt: props.state.global_user_data.data.token,
        expireDate: pictures[0]?.expires || null,
        ordem: order ? Number(order) : null,
      };
      const data = await createSchedule(dataApi);

      if (data.message === "AGENDA_CREATED") {
        if (isComGas()) {
          await createScheduleQuotas({
            eventId: props.idEvent,
            agendaId: data.agenda.id,
            qtdCotas: qtdQuotas,
            jwt: props.state.global_user_data.data.token,
          });
        }
        setsuccess_dlg(true);
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setIsloading(false);
    }
  }

  async function getGroupsFunc() {
    try {
      const response = await getGroups({
        jwt: props.state.global_user_data.data.token,
        eventId: props.idEvent,
        offset: 1,
        limit: 0,
        search: "",
      });
      setGroups(response.findOneGroupData.data);
    } catch (error) {
      // erro tratado silenciosamente
    }
  }

  useEffect(() => {
    getGroupsFunc();
    getSpeakers();
  }, []);

  return (
    <Modal isOpen={isOpen} toggle={toggle} autoFocus={true} centered={true}>
      {errorAlert && (
        <SweetAlert error title={"Erro"} onConfirm={() => setErrorAlert(false)}>
          {"Erro ao fazer upload das imagens."}
        </SweetAlert>
      )}
      {success_dlg ? (
        <SweetAlert
          success
          title={"Criado"}
          onConfirm={() => {
            props.refetch();
            setsuccess_dlg(false);
            toggle();
          }}
        >
          {"Programação criada com sucesso!"}
        </SweetAlert>
      ) : null}
      <ModalHeader toggle={toggle}>Nova Programação</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            funcPhoto();
          }}
        >
          <Row>
            <Col lg={12}>
              <div>
                <label className="form-label">Titulo*</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setTitle(e.target.value)}
                />
                {titleError && (
                  <span style={{ color: "red" }}>{titleError}</span>
                )}
              </div>
            </Col>
          </Row>
          {(isApp() || isRsvp()) && (
            <Row style={{ marginTop: 10 }}>
              <Col lg={12}>
                <div>
                  <label className="form-label">Descrição</label>
                  <textarea
                    className="form-control"
                    type="text"
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          )}
          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Data da Programação*</label>
                <input
                  className="form-control"
                  type="date"
                  id="example-datetime-local-input"
                  onChange={(e) => setStartDate(e.target.value)}
                />
                {dateError && <span style={{ color: "red" }}>{dateError}</span>}
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={6}>
              <div>
                <label className="form-label">Hora Início</label>
                <input
                  className="form-control"
                  type="time"
                  id="start-datetime-local-input"
                  onChange={(e) => setStartHour(e.target.value)}
                />
                {hourStartError && (
                  <span style={{ color: "red" }}>{hourStartError}</span>
                )}
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <label className="form-label">Hora Fim</label>
                <input
                  className="form-control"
                  type="time"
                  id="end-datetime-local-input"
                  onChange={(e) => setEndHour(e.target.value)}
                />
                {hourEndError && (
                  <span style={{ color: "red" }}>{hourEndError}</span>
                )}
              </div>
            </Col>
          </Row>

          {(isApp() || isRsvp()) && (
            <>
              <Row style={{ marginTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">Imagem 1</label>
                    <Input
                      className="form-control"
                      type="file"
                      id="formFile1"
                      onChange={(e) => setImg1(e.target.files?.[0])}
                    />
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">Imagem 2</label>
                    <Input
                      className="form-control"
                      type="file"
                      id="formFile2"
                      onChange={(e) => setImg2(e.target.files?.[0])}
                    />
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">Imagem 3</label>
                    <Input
                      className="form-control"
                      type="file"
                      id="formFile3"
                      onChange={(e) => setImg3(e.target.files?.[0])}
                    />
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">Imagem 4</label>
                    <Input
                      className="form-control"
                      type="file"
                      id="formFile4"
                      onChange={(e) => setImg4(e.target.files?.[0])}
                    />
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">Imagem 5</label>
                    <Input
                      className="form-control"
                      type="file"
                      id="formFile5"
                      onChange={(e) => setImg5(e.target.files?.[0])}
                    />
                  </div>
                </Col>
              </Row>
            </>
          )}
          {(isApp() || isRsvp()) && (
            <Row style={{ marginTop: 10 }}>
              <Col lg={12}>
                <div>
                  <label className="form-label">
                    Tipo/Local da Programação
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    onChange={(e) => setTypeOrLocation(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          )}
          {(isApp() || isRsvp()) && (
            <Row style={{ marginTop: 10 }}>
              <Col lg={12}>
                <ColorPicker
                  classOfContainer="bg-edit-shedule-event-pickr"
                  labelText="Cor da Programação"
                  setStateFunc={setBackgroundColor}
                />
              </Col>
            </Row>
          )}

          {isComGas() && (
            <Row style={{ marginTop: 10 }}>
              <Col lg={12}>
                <div>
                  <label className="form-label">Quantidade de Cotas*</label>
                  <input
                    className="form-control"
                    type="number"
                    onChange={(e) => setQtdQuotas(e.target.value)}
                  />
                  {quotasError && (
                    <span style={{ color: "red" }}>{quotasError}</span>
                  )}
                </div>
              </Col>
            </Row>
          )}
          {(isApp() || isRsvp()) && (
            <>
              <Row style={{ marginTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">Ordem</label>
                    <input
                      className="form-control"
                      type="number"
                      onChange={(e) => setOrder(e.target.value)}
                    />
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">Palestrantes</label>
                    <Select
                      value={speakersMulti}
                      placeholder={"Selecione"}
                      isMulti={true}
                      onChange={(e) => {
                        handleSpeakersMulti(e);
                      }}
                      noOptionsMessage={() => "Nenhuma opção encontrada"}
                      options={[
                        {
                          options:
                            speakers.length > 0 && !allSpeakers
                              ? [
                                  { label: "TODOS", value: "todos" },
                                  ...speakers.map((e) => {
                                    return { label: e.name, value: e.id };
                                  }),
                                ]
                              : [],
                        },
                      ]}
                      classNamePrefix="select2-selection"
                    />
                  </div>
                </Col>
              </Row>
            </>
          )}

          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Grupos</label>
                <Select
                  value={groupsMulti}
                  placeholder={"Selecione"}
                  isMulti={true}
                  onChange={(e) => {
                    handleGroupMulti(e);
                  }}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  options={[
                    {
                      options:
                        groups.length > 0 && !allGroups
                          ? [
                              { label: "TODOS", value: "todos" },
                              ...groups.map((e) => {
                                return { label: e.name, value: e.id };
                              }),
                            ]
                          : [],
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              margin: "20px auto 0 auto",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              color="danger"
              style={{ width: 80, marginRight: 10 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>
            <ButtonSpinner isLoading={isLoading} title={"Salvar"} />
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(NewSchedule);
